import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconComponentProps } from '../IconTypes';
import { IconWrapper } from '../IconWrapper';

import { faFilter } from '@fortawesome/pro-light-svg-icons';

export type ProLightFilterProps = IconComponentProps;

export const ProLightFilter = ({
  className,
  onClick,
  iconProps,
  type = 'button',
  ...props
}: ProLightFilterProps) => {
  if (onClick) {
    return (
      <IconWrapper
        {...props}
        className={['font-awesome-button', className].join(' ')}
        type={type}
        onClick={onClick}
      >
        <FontAwesomeIcon
          {...iconProps}
          className="font-awesome-icon"
          icon={faFilter}
        />
      </IconWrapper>
    );
  }
  return (
    <FontAwesomeIcon
      {...iconProps}
      className={['font-awesome-icon', className].join(' ')}
      icon={faFilter}
    />
  );
};

ProLightFilter.displayName = 'ProLightFilter';
